module.exports = __webpack_public_path__ + "static/img/shoes_left.19e47cc2.png";